import { useEffect } from 'react';

import mixpanel from 'mixpanel-browser';

export const useTrackAnchorClicks = () => {
    useEffect(() => {
        const handleClick = (event: MouseEvent) => {
            if (!(event.target instanceof Element)) {
                return;
            }

            const anchor =
                event.target.closest<HTMLElement>('[data-track-event]');
            const eventName = anchor?.dataset.trackEvent;

            if (!eventName) {
                return;
            }

            mixpanel.track(eventName, undefined, { transport: 'sendBeacon' });
        };

        document.addEventListener('click', handleClick, true);

        return () => {
            document.removeEventListener('click', handleClick, true);
        };
    }, []);
};
